import { Component, ElementRef, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

let componentID: number = 0;

@Component({
	standalone: false,
	selector: 'visiba-succesBox',
	template: `
		<div class="succesBox__container">
			<div class="succesBox__header">
				<visiba-svg class="succesBox__check" a="CheckWithCircle"></visiba-svg>
				<div class="succesBox__exit" (click)="toggle(false)">
					<visiba-svg a="X"></visiba-svg>
				</div>
			</div>
			<div class="succesBox__info">
				<h2>{{ title }}</h2>
				<p>{{ info }}</p>
				<a *ngIf="receiptUrl" class="succesBox__receiptUrl" [href]="receiptUrl">{{
					'LicenceHolder.Messaging.Header.Phrase.SaveReciept' | translate
				}}</a>
				<div [ngSwitch]="mode" class="succesBox__action">
					<div *ngSwitchCase="'return'" class="btn" (click)="toggle(false)">{{ button }}</div>
					<a *ngSwitchCase="'href'" [href]="href" class="succesBox__href" (click)="action()">{{ button }}</a>
				</div>
			</div>
		</div>
	`,
	host: {
		class: 'succesBox',
		'[attr.mode]': 'mode',
	},
	styleUrls: ['../Css/Components/succesBox.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class succesBox {
	show: boolean = false;
	componentID: number = componentID++;

	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	@Output() onState: EventEmitter<any> = new EventEmitter();
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	@Output() onToggle: EventEmitter<any> = new EventEmitter();
	@Input() mode: 'return' | 'href' | 'none' = 'return';
	@Input() href: string = '#__HREF__';
	@Input() title: string = '__TITLE__';
	@Input() info: string = '__INFO__';
	@Input() button: string = '__BUTTON__';
	@Input() receiptUrl: string | null = null;

	// biome-ignore lint/suspicious/noEmptyBlockStatements: suppressed due to migration - should be fixed
	constructor() {}

	toggle(e) {
		this.show = e || !this.show;
		this.onToggle.emit(this.show);
	}

	action() {
		this.onState.emit(true);
	}
}
